import { getSrqDiagnosticsApiParams } from '../../utils/getSrqApiParams'
import { ChapterViewApiParams } from '../types/api'

export const getChapterApiParams = (): ChapterViewApiParams =>
  getSrqDiagnosticsApiParams()
